import type { Workspace } from "./workspace-list";
import { TONES } from "@people-ai/planets";

/* The console's workspaces for a platform member outside any organization (PEO-246); never shown
 * inside a tenant. */
export const PLATFORM_WORKSPACES: readonly Workspace[] = [
  {
    id: "tenant",
    label: "Tenant",
    blurb: "Every customer organization: plans, features, billing and add-ons.",
    home: "/platform",
    groups: [],
    items: ["platform-console", "plans-modules"],
    owns: ["/platform", "/settings/plans-modules", "/admin/plans-modules"],
    accent: "#5B5F97",
  },
  {
    id: "support-desk",
    label: "Support desk",
    blurb: "What customers asked us for and told us about Aria, and the answers.",
    home: "/support-desk",
    groups: [],
    items: ["support-desk", "platform-form-requests", "platform-aria-feedback"],
    owns: ["/support-desk", "/platform/form-requests", "/platform/aria-feedback"],
    accent: "#B4532A",
  },
  {
    id: "luna",
    label: "Luna",
    blurb: "People AI's own front desk: the calls to our lines.",
    home: "/platform/calls",
    groups: [],
    items: ["platform-calls", "platform-lines", "platform-desk"],
    owns: ["/platform/calls", "/platform/lines", "/platform/desk"],
    accent: TONES.luna.ink,
  },
  {
    id: "pam",
    label: "Pam",
    blurb: "People AI's own sales: the texting line and its leads.",
    home: "/platform/conversations",
    groups: [],
    items: ["platform-conversations", "platform-leads", "platform-sales-assistant"],
    owns: ["/platform/conversations", "/platform/leads", "/platform/sales-assistant"],
    accent: TONES.pam.ink,
  },
  {
    id: "abby",
    label: "Abby",
    blurb: "The platform team: who is on it, their roles and what they did.",
    home: "/platform/team",
    groups: [],
    items: ["platform-team", "platform-roles", "platform-activity"],
    owns: ["/platform/team", "/platform/roles", "/platform/activity"],
    accent: TONES.abby.ink,
  },
  {
    id: "settings",
    label: "Settings",
    blurb: "Your own account, and how the whole platform runs.",
    home: "/settings/profile",
    groups: [],
    items: ["platform-settings", "assistive-devices"],
    owns: ["/ws/settings", "/settings", "/platform/settings"],
    accent: "#4B4B5C",
  },
];
